import Appliance from "../assets/Card Images/appliance.png"
import Appliance_Repair from "../assets/Card Images/Appliance_Repair.png"
import BBQ_Cleaning from "../assets/Card Images/BBQ_Cleaning.png"
import Carpet_Upholstery from "../assets/Card Images/Carpet_&_Upholstery.png"
import Duct_Cleaning from "../assets/Card Images/Duct_Cleaning.png"
import Electrical from "../assets/Card Images/Electrical.png"
import Junk_Removal from "../assets/Card Images/Junk_Removal.png"
import Holiday_Lights from "../assets/Card Images/Holiday_Lights.png"
import Furniture_Assembly from "../assets/Card Images/Furniture_Assembly.png"
import Garage_Door_Repair from "../assets/Card Images/Garage_Door_Repair.png"
import Gas_Services from "../assets/Card Images/Gas_Services.png"
import Lawn_Maintenance from "../assets/Card Images/Lawn_Maintenance.png"
import Heating_Cooling from "../assets/Card Images/Heating_&_Cooling.png"
import Home_Inspection from "../assets/Card Images/Home_Inspection.png"
import Locksmith from "../assets/Card Images/Locksmith.png"
import Painting from "../assets/Card Images/Painting.png"
import Pest_Control from "../assets/Card Images/Pest_Control.png"
import Power_Wash from "../assets/Card Images/Power_Wash.png"
import Window_Eaves from "../assets/Card Images/Window_&_Eaves.png"
import Mobile_Auto_Detail from "../assets/Card Images/Mobile_Auto_Detail.png"
import Plumbing from "../assets/Card Images/Plumbing.png"
import Moving_Delivery from "../assets/Card Images/Moving_&_Delivery.png"
import Snow_Removal from "../assets/Card Images/Snow_Removal.png"
import Handyman_Services from "../assets/Card Images/Handyman_Services.png"


export const CardData = [
    {
        title: "Appliance Install",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Appliance
    },
    {
        title: "Appliance Repair",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Appliance_Repair
    },
    {
        title: "BBQ Cleaning",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: BBQ_Cleaning
    },
    {
        title: "Carpet & Upholstery",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Carpet_Upholstery
    },
    {
        title: "Duct Cleaning",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Duct_Cleaning
    },
    {
        title: "Electrical",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Electrical
    },
    {
        title: "Junk Removal",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Junk_Removal
    },
    {
        title: "Holiday Lights",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Holiday_Lights
    },
    {
        title: "Furniture Assembly",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Furniture_Assembly
    },
    {
        title: "Garage Door Repair",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Garage_Door_Repair
    },
    {
        title: "Gas Services",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Gas_Services
    },
    {
        title: "Lawn Maintenance",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Lawn_Maintenance
    },
    {
        title: "Heating & Cooling",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Heating_Cooling
    },
    {
        title: "Home Inspection",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Home_Inspection
    },
    {
        title: "Locksmith",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Locksmith
    },
    {
        title: "Painting",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Painting
    },
    {
        title: "Pest Control",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Pest_Control
    },
    {
        title: "Power Wash",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Power_Wash
    },
    {
        title: "Window & Eaves",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Window_Eaves
    },
    {
        title: "Mobile Auto Detail",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Mobile_Auto_Detail
    },
    {
        title: "Plumbing",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Plumbing
    },
    {
        title: "Moving & Delivery",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Moving_Delivery
    },
    {
        title: "Snow Removal",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Snow_Removal
    },
    {
        title: "Handyman Services",
        subTitle: 'Gorem ipsum dolor sit amet, consectetur adipiscing elit.',
        img: Handyman_Services
    },

]


export const CANADA_SEASONS = [
  { value: "spring", label: "Spring (March - May)" },
  { value: "summer", label: "Summer (June - August)" },
  { value: "fall", label: "Fall/Autumn (September - November)" },
  { value: "winter", label: "Winter (December - February)" },
  { value: "once_a_year", label: "Once a Year" },
  { value: "every_3_years", label: "Every 3 Years" },
];